import {
  Component,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
  ViewChild,
  ViewChildren,
  QueryList,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CategoryService } from '@app/api/api';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { UtilService } from '@app/services/util.service';
import { SystemSettingService } from '@app/api/systemsettting.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'meu-app-home-page-category-banner',
  templateUrl: './app-home-page-category-banner.component.html',
  styleUrls: ['./app-home-page-category-banner.component.scss'],
})
export class AppHomePageCategoryBannerComponent implements OnInit, OnDestroy {
  host = environment.backendhost;
  iconCategoryDefault = '/assets/media/icons/svg/maintenance.svg';
  maxItemMenu = 13;
  lineHeightMenu = 42;

  listCategory = [];
  listCategoryFull = [];
  listCategoryMenuAll = [];

  mx = -1;

  listImageBanner: any[] = [];

  indexChooseImage = 1;
  scrollObservable: Subscription;
  treeCategory: any[] = [];
  childrenCategory: any[] = [];
  hoverId: number | null = null;

  @ViewChild('sliderList', { static: false }) sliderList!: ElementRef;
  @ViewChildren('item') items!: QueryList<ElementRef>;
  @ViewChildren('dot') dots!: QueryList<ElementRef>;
  active = 0;
  autoSlideInterval: any;

  constructor(
    private cd: ChangeDetectorRef,
    private categoryService: CategoryService,
    private router: Router,
    private sysService: SystemSettingService
  ) {}

  getWidth() {
    var el = document.getElementById('categoryTitle');
    if (el && screen.width >= 1014) {
      return el.clientWidth - 50;
    }
    return -1;
  }

  ngOnInit() {
    this.getListCategory();
    this.getBanners();
  }

  getBanners() {
    this.sysService
      .apiSystemSettingGet('type==BANNER')
      .pipe(
        map((res) => {
          if (res.success && res.data.collection.length > 0) {
            const parent = res.data.collection[0];
            if (parent.children && parent.children.length > 0) {
              return parent.children
                .filter((item) => item.is_hidden === false && item.value)
                .map((item) => {
                  return {
                    id: item.id,
                    path: this.host + item.value,
                  };
                });
            }
          }
          return [];
        })
      )
      .subscribe((data) => {
        this.listImageBanner = data;
        this.cd.detectChanges();

        setTimeout(() => {
          this.active = 0;
          this.updateSlidePosition();
          this.stopAutoSlide();
          this.startAutoSlide();
        }, 100);
      });
  }

  getListCategory() {
    this.categoryService.apiCategoriesWithPriority(true, 'body', true).subscribe((res) => {
      if (res.success && res.data.length > 0) {
        this.listCategoryFull = res.data.filter((x) => !x.parent_id);

        this.listCategory = [...this.listCategoryFull];

        this.listCategory.map((item) => {
          item.image = item.image ? this.host + item.image : this.iconCategoryDefault;
          item['children'] = res.data.filter((x) => x.parent_id === item.id);
        });

        this.listCategoryMenuAll = [];
        let k = 0;
        let arr: any[] = [];
        for (let i = 0; i < this.listCategoryFull.length; i++) {
          if (k === this.maxItemMenu) {
            this.listCategoryMenuAll.push({ colMenu: arr });
            k = 0;
            arr = [];
            i--;
          } else {
            arr.push(this.listCategoryFull[i]);
            k++;
          }
        }
        if (arr.length > 0) {
          this.listCategoryMenuAll.push({ colMenu: arr });
        }

        this.cd.detectChanges();
      }
    });
  }

  onHoverCategory(id) {
    this.hoverId = id;
    this.childrenCategory = this.listCategory.find((x) => x.id === id).children;
  }

  onLeaveCategory() {
    this.hoverId = null;
  }

  getProductByCategory(item) {
    this.router.navigate(['/searchbycategory'], {
      queryParams: {
        categoryId: item.id,
        categoryName: UtilService.slugify(item.name),
      },
    });
  }

  ngAfterViewInit() {
    this.mx = this.getWidth();
    this.cd.detectChanges();
    setTimeout(() => {
      if (this.listImageBanner.length > 0) {
        this.updateSlidePosition();
        this.startAutoSlide();
      }
    }, 0);
  }

  nextClick() {
    if (!this.items || this.items.length === 0) return;

    this.stopAutoSlide();
    if (this.active < this.items.length - 1) {
      this.active++;
    } else {
      this.active = 0;
    }
    this.updateSlidePosition();
    this.startAutoSlide();
  }

  prevClick() {
    if (!this.items || this.items.length === 0) return;

    this.stopAutoSlide();
    if (this.active > 0) {
      this.active--;
    } else {
      this.active = this.items.length - 1;
    }
    this.updateSlidePosition();
    this.startAutoSlide();
  }

  onDotClick(item: number) {
    this.active = item;
    this.updateSlidePosition();
  }

  updateSlidePosition() {
    if (!this.items || !this.sliderList) return;

    const itemArray = this.items.toArray();
    const dotArray = this.dots.toArray();

    if (itemArray.length > 0 && itemArray[this.active]) {
      const offset = itemArray[this.active].nativeElement.offsetLeft;
      this.sliderList.nativeElement.style.transform = `translate3d(${-offset}px, 0, 0)`;

      dotArray.forEach((dot, index) => {
        if (index === this.active) {
          dot.nativeElement.classList.add('active');
        } else {
          dot.nativeElement.classList.remove('active');
        }
      });
    }
  }

  startAutoSlide() {
    if (this.listImageBanner.length > 1) {
      this.autoSlideInterval = setInterval(() => {
        this.nextClick();
      }, 4000);
    }
  }

  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateSlidePosition();
    this.mx = this.getWidth();
  }

  ngOnDestroy() {
    this.stopAutoSlide();
  }
}
